import React from 'react';
import styles from '../demo/Playlist.module.css';
import { useLocation } from 'react-router-dom';
import PaginationExample from '../demo/Pagination.js';

const Playlist = () => {
  const location = useLocation();
  const { pageTitle = "Media Content" } = location.state || {};

  return (
    <div className={styles.outerMostdiv}>
      <div>
        <div className={styles.outerHeading}>
          <h1 className={styles.Media_title}>{pageTitle}</h1>
        </div>
      </div>
      <PaginationExample />
    </div>
  );
};

export default Playlist;